import React from 'react';
import { Link } from 'react-router-dom';

export default function Planos() {
  return (
    <div id="planos" className="container-fluid planos-section">
      <div className="text-center planos-header">
        <h2>Planos Quantum Trades EA</h2>
        <h4>
          Escolha o plano ideal para a quantidade de contas MT5 (USC ou Standard) que você utiliza.
        </h4>
        <p className="planos-subtitle">
          Todos os planos incluem:
          <br />
          <strong>
            Acesso completo ao EA, atualizações, suporte, manual detalhado e portfólios prontos
          </strong>{' '}
          para contas a partir de <strong>US$ 150 (15.000 USC)</strong>.
        </p>
      </div>

      <div className="row">

        {/* === Plano Starter === */}
        <div className="col-lg-4 col-md-6 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading">
              <h1>Starter</h1>
            </div>
            <div className="panel-body">
              <p><strong>2 contas MT5 incluídas</strong></p>
              <p>Ideal para começar a operar com o robô</p>
              <p>Possibilidade de adicionar contas extras</p>
            </div>
            <div className="panel-footer">
              {/* BRL */}
              <h3>R$ 20,00 / mês</h3>
              <p>
                <h4>Contas extras: R$ 10,00 por conta</h4>
              </p>
              {/* USD */}
              <p style={{ marginTop: '10px' }}>
                <strong>Clientes internacionais:</strong><br />
                US$ 6,00 / mês &mdash; contas extras: US$ 3,00 por conta
              </p>
              <Link className="btn btn-lg" to="/cadastro">
                Assinar
              </Link>
            </div>
          </div>
        </div>

        {/* === Plano Trader === */}
        <div className="col-lg-4 col-md-6 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading">
              <h1>Trader</h1>
            </div>
            <div className="panel-body">
              <p><strong>5 contas MT5 incluídas</strong></p>
              <p>Perfeito para quem opera várias estratégias</p>
              <p>Mais contas, menor valor por conta extra</p>
            </div>
            <div className="panel-footer">
              {/* BRL */}
              <h3>R$ 40,00 / mês</h3>
              <p>
                <h4>Contas extras: R$ 9,00 por conta</h4>
              </p>
              {/* USD */}
              <p style={{ marginTop: '10px' }}>
                <strong>Clientes internacionais:</strong><br />
                US$ 12,00 / mês &mdash; contas extras: US$ 2,50 por conta
              </p>
              <Link className="btn btn-lg" to="/cadastro">
                Assinar
              </Link>
            </div>
          </div>
        </div>

        {/* === Plano Pro === */}
        <div className="col-lg-4 col-md-6 col-xs-12">
          <div className="panel panel-default text-center">
            <div className="panel-heading">
              <h1>Pro</h1>
            </div>
            <div className="panel-body">
              <p><strong>10 contas MT5 incluídas</strong></p>
              <p>Focado em quem gerencia várias contas e estratégias</p>
              <p>Perfeito para portfólios completos e otimização por capital</p>
            </div>
            <div className="panel-footer">
              {/* BRL */}
              <h3>R$ 70,00 / mês</h3>
              <p>
                <h4>Contas extras: R$ 8,00 por conta</h4>
              </p>
              {/* USD */}
              <p style={{ marginTop: '10px' }}>
                <strong>Clientes internacionais:</strong><br />
                US$ 21,00 / mês &mdash; contas extras: US$ 2,00 por conta
              </p>
              <Link className="btn btn-lg" to="/cadastro">
                Assinar
              </Link>
            </div>
          </div>
        </div>

      </div>

      <div className="planos-disclaimer text-center">
        <p>
          <small>
            Os valores e condições podem ser ajustados ao longo do tempo. Resultados obtidos com o
            EA dependem de configurações, corretora, VPS, perfil de risco e condições de mercado.
            Desempenhos passados não garantem resultados futuros.
          </small>
        </p>
      </div>
    </div>
  );
}
